import { writable } from 'svelte/store';

function paymentProviderStore() {
    const { subscribe, set, update } = writable({
        provider_id: "stripe", // default
        use_smart_fields: false,
        smart_fields_data: null,
    });

    return {
        subscribe,
        setProvider: (id) => update(s => ({ ...s, provider_id: id })),
        setUseSmartFields: (val) => update(s => ({ ...s, use_smart_fields: val })),
        setSmartFieldsData: (data) => update(s => ({ ...s, smart_fields_data: data })),
        reset: () => set({ provider_id: "stripe", use_smart_fields: false, smart_fields_data: null })
    };
}

export const PaymentProviderStore = paymentProviderStore();
